import React from 'react';

import { BirthPlan, BirthPlanService } from '../../general/ServerClient';
import { useAppContext } from '../page/WebappContext';
import {
  UpdateProfileButtonList,
  UpdateProfileInformationDialog
} from './UpdateProfileInformationDialog';

export const UpdateBirthLocationDialog: React.FC<{
  isOpen: boolean;
  dismiss: () => void;
}> = ({ isOpen, dismiss }) => {
  const { birthPlan, options } = useAppContext();

  return (
    <UpdateProfileInformationDialog
      open={isOpen}
      onClose={dismiss}
      title="Who's leading your care?"
    >
      {options.data ? (
        <UpdateProfileButtonList
          options={options.data.locations}
          onCancel={dismiss}
          initialSelectedId={birthPlan.data?.birth_location}
          onSubmit={(selectedId) => {
            if (birthPlan.data) {
              const newBirthPlan: BirthPlan = {
                ...birthPlan.data,
                birth_location: selectedId
              };
              birthPlan.setData(newBirthPlan);
              BirthPlanService.birthPlanProfileCreate(newBirthPlan);
            }
            dismiss();
          }}
        />
      ) : (
        <div>Error: no birth plan options</div>
      )}
    </UpdateProfileInformationDialog>
  );
};
